// Collection Listing Tabbing

function openTabNew(evt, tabNames) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabNewContent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tabNewLinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(tabNames).style.display = "block";
    evt.currentTarget.className += " active";
  }
  document.getElementById("defaultOpenNew").click();




// // Collection Listing Tabbing

// function openTab(evt, tabName) {
//     var i, tabcontent, tablinks;
//     tabcontent = document.getElementsByClassName("tabContent");
//     for (i = 0; i < tabcontent.length; i++) {
//       tabcontent[i].style.display = "none";
//     }
//     tablinks = document.getElementsByClassName("tabLinks");
//     for (i = 0; i < tablinks.length; i++) {
//       tablinks[i].className = tablinks[i].className.replace(" active", "");
//     }
//     document.getElementById(tabName).style.display = "block";
//     evt.currentTarget.className += " active";
//   }
//   document.getElementById("defaultOpen").click();












//   Collection Slider
$(document).ready(function(){
    $('.productMainImage').owlCarousel({
       loop: true,
        items: 1,
        slideSpeed: 2000,
        thumbs: true,
        thumbImage: true,
        dots: false,
        thumbContainerClass: 'owl-thumbs',
        thumbItemClass: 'owl-thumb-item'
       });
    });


// Organic Cotton Slider

$(document).ready(function(){
    $('.organicCottonSlider').owlCarousel({
       loop: true,
        items: 1,
        slideSpeed: 2000,
        thumbs: false,
        thumbImage: false,
        dots: false,
        nav:true,
        navText: ["<i class='fal fa-long-arrow-left'></i>","<i class='fal fa-long-arrow-right'></i>"]
       });
    });

